import React from 'react';

import PeriodColgateList  from 'components/Tvendo/Sale/QuotaBPartner/Colgate/PeriodColgate/List.js';

export default function () {
  return <PeriodColgateList  />;
}